module.exports = __webpack_public_path__ + "img/HomeShaderEditor.e16b3bdc.gif";